import { useEffect } from 'react';

import { useAppDispatch } from '../../../store/hooks';
import { DispatchActionModel } from './models/dispatch-action.model';

export const useOnFeatureClearingStates = (
  actions: DispatchActionModel[]
): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      actions.forEach(action => dispatch(action));
    };
  }, []);
};
